import { tienFormat, tienFormatSms } from "../utils/NumberUtils";

export const BetUtils = {
    exportSoCuoc: (payload: {
        soCuocFieldName: string, datas: any[]
        , sttTu: number, sttDen: number,
        tien: number, heSo: number,
    }): string => {

        // let dau = ""
        // let cuoi = ""
        let sms="";
        let { soCuocFieldName, datas, sttTu, sttDen, tien, heSo } = payload;
        let giua = (sttDen + 1 - sttTu) / 2 + sttTu - 1
        if (sttDen > datas.length)
            sttDen = datas.length;
        if (sttTu < 0)
            sttTu = 0;
        for (let i = sttTu - 1; i < sttDen; i++) {
            const so = datas[i][soCuocFieldName]
            // if (i < giua) {
            //     dau += dau == "" ? so : `,${so}`
            // } else {
            //     cuoi += cuoi == "" ? so : `,${so}`
            // }
            sms += sms == "" ? so : `,${so}`
        }
        //console.log(`dau ${(dau.length + 1) / 3}, cuoi ${(cuoi.length + 1) / 3}`)

        // return `de ${dau}x${tien}n. ${cuoi}x ${ tienFormatSms(tien * heSo, 0)}n`
        return `${sms} \n`
    }

}